// shared/SelectInput.tsx
interface SelectInputProps {
    label: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    options: { value: string; label: string }[];
    required?: boolean;
  }
  
  const SelectInput: React.FC<SelectInputProps> = ({ label, name, value, onChange, options, required = false }) => (
    <div className="flex flex-col space-y-1">
            <label htmlFor={name} className="block text-sm font-medium text-white/90 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <select
        name={name}
        value={value}
        onChange={onChange}
        className="w-full bg-black bg-opacity-50 border border-gray-500 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-yellow-400"
      >
        <option value="">Select {label}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
  
  export default SelectInput;
  